import { useEffect } from 'react';
import { useCountdown } from '../../core/hooks/useCounter';

interface CountdownTimerProps {
    targetDate: any,
    onExpired: () => void
}

const CountdownTimer = (props: CountdownTimerProps) => {
    const { targetDate, onExpired } = props;
    const [minutes, seconds] = useCountdown(targetDate);

    useEffect(() => {
        if (minutes + seconds <= 0) {
            onExpired();
            return;
        }
    }, [minutes, seconds]);

    return (
        <>
            {minutes + seconds !== 0 && (
                <div className="show-counter" style={{margin: "0 16px"}}>
                    <p>{minutes}:{seconds}</p>
                </div>
            )}
        </>
    )
};

export default CountdownTimer;
